import React, {
    useContext, useCallback, useState, useEffect
} from 'react';
import _ from 'lodash';
import { ServiceManager } from '@jutro/legacy/services';
import { ViewModelServiceContext, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';

import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { MockUpUtil } from '@xengage/gw-portals-util-js';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import metadata from './PolicyInformationPage.metadata.json5';
import './PolicyInformationPage.messages';
import { BreakpointTrackerContext } from '@jutro/legacy/layout';

function removeInitialData(submissionVM) {
    // eslint-disable-next-line no-param-reassign
    submissionVM.value = MockUpUtil.cleanUpMockedProperties(
        _.get(submissionVM, 'value'),
        'quote.bop',
        'bindData.contactPhone',
        'bindData.contactEmail',
        'baseData.accountHolder.emailAddress1'
    );
    return submissionVM;
}

function initialiseVM(submissionVM) {
    const vm = removeInitialData(submissionVM);

    vm.bindData.value = vm.bindData.value || {};
    vm.bindData.billingAddress.value = vm.bindData.billingAddress.value
    || vm.baseData.policyAddress.value;
    vm.bindData.contactEmail.value = vm.bindData.contactEmail.value
    || vm.baseData.accountHolder.emailAddress1.value;

    return vm;
}

function PolicyInformationPage(props) {
    const { wizardData: submissionVM, updateWizardData } = props;
    const viewModelService = useContext(ViewModelServiceContext);
    const breakpoint = useContext(BreakpointTrackerContext);
    const [isSameBillingAddress, updateIsSameBillingAddress] = useState(true);
    const [isVmInitialized, updateIsVmInitialized] = useState(false);
    const localeService = ServiceManager.getService('locale-service');
    const { onValidate, isComponentValid } = useValidation('PolicyInformationPage');

    useEffect(() => {
        if (!isVmInitialized) {
            let nextSubmissionVM = viewModelService.clone(submissionVM);
            nextSubmissionVM = initialiseVM(nextSubmissionVM);

            if (!_.isEqual(submissionVM.value, nextSubmissionVM.value)) {
                updateWizardData(nextSubmissionVM);
            }
            updateIsVmInitialized(true);
        }
    }, [isVmInitialized, submissionVM, updateWizardData, viewModelService]);

    const handleNext = useCallback(async () => {
        if (isSameBillingAddress) {
            const policyAddress = _.get(submissionVM, 'baseData.policyAddress.value');
            _.set(submissionVM, 'bindData.billingAddress.value', policyAddress);
        }
        return submissionVM;
    }, [isSameBillingAddress, submissionVM]);

    const overrideProps = {
        '@field': {
            // apply to all fields
            showOptional: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        sameBillingAddress: {
            value: isSameBillingAddress,
            onValueChange: updateIsSameBillingAddress
        },
        billingAddressFields: {
            visible: !isSameBillingAddress
        },
        phoneNumber: {
            countryCode: localeService.getDefaultPhoneCountry()
        }
    };

    const resolvers = {
        resolveCallbackMap: {
            updateIsSameBillingAddress
        }
    };

    const readValue = useCallback(
        (id, path) => {
            return readViewModelValue(metadata.pageContent, submissionVM, id, path, overrideProps);
        },
        [submissionVM, overrideProps]
    );

    return (
        <WizardPage onNext={handleNext} disableNext={!isComponentValid}>
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={submissionVM}
                overrideProps={overrideProps}
                onModelChange={updateWizardData}
                onValidationChange={onValidate}
                callbackMap={resolvers.resolveCallbackMap}
                resolveValue={readValue}
            />
        </WizardPage>
    );
}

PolicyInformationPage.propTypes = wizardProps;
export default PolicyInformationPage;
